<script setup lang="ts">
defineProps({
  count: {
    type: Number,
    default: 0,
  },
})
</script>

<template>
  <div
    v-if="count"
    class="text-h8-semibold bg-coral rounded-24 min-w-16 min-h-16 inline-flex shrink-0 grow-0 items-center justify-center leading-none text-white"
    :class="{
      'px-2': count > 9,
    }"
  >
    {{ count > 99 ? '99+' : count }}
  </div>
</template>
